import type { ReactNode } from 'react';

export const symbol_align_horizontal_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M828.5-88.63Q820-97.25 820-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM370-290q-20.83 0-35.42-14.62Q320-319.24 320-340.12q0-20.88 14.58-35.38Q349.17-390 370-390h300q20.83 0 35.42 14.62Q720-360.76 720-339.88q0 20.88-14.58 35.38Q690.83-290 670-290H370ZM130-570q-20.83 0-35.42-14.62Q80-599.24 80-620.12 80-641 94.58-655.5 109.17-670 130-670h540q20.83 0 35.42 14.62Q720-640.76 720-619.88q0 20.88-14.58 35.38Q690.83-570 670-570H130Z"
		/>
	</svg>
);
